import queryString from "query-string"
import JsCookie from "js-cookie"

import * as authApi from "./authApi"
import cuckoo from "common/services/cuckoo/cuckoo"
import { showModal } from "common/services/modals/actions"
import { cuckooEvents } from "common/consts/enums"

function verifyEmail(token, store) {
  cuckoo.track(cuckooEvents.AUTH_PASSWORD_VERIFY_REQUEST)
  authApi.verifyEmail(token).then(
    () => {
      cuckoo.track(cuckooEvents.AUTH_PASSWORD_VERIFY_SUCCESS)
      store.dispatch(showModal("verifyEmail"))
    },
    err => {
      cuckoo.track(cuckooEvents.AUTH_PASSWORD_VERIFY_ERROR, err)
      store.dispatch(showModal("errorModal", { error: err.message }))
    },
  )
}

function offerCreatingPassword(token, store) {
  store.dispatch(showModal("creatingPassword", { token }))
}

export default function(store) {
  const query = queryString.parse(window.location.search)

  const token = JsCookie.get(`${query.action}_token`)

  if (query.action === "verifyEmail") {
    verifyEmail(token, store)
  }

  if (query.action === "resetPassword") {
    offerCreatingPassword(token, store)
  }
}
